<template>
  <div
    class="page_container goodsManageSet"
    v-loading="loading"
    element-loading-text="请稍后"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >物流&订单管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/outboundIndex/outboundList' }"
          >出库管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/outboundIndex/outboundDetail' }"
          >订单详情</el-breadcrumb-item
        >
        <el-breadcrumb-item>发货</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!--  主要内容 start -->
    <div class="form_container">
      <h1>发货信息设置</h1>
      <div class="content_wrap flex-between">
        <div class="form_wrap">
          <div class="block">
            <p><span class="mark">*</span>订单物流状态</p>
            <div class="radio_box" style="margin-bottom: 10px">
              <el-radio-group
                direction="horizontal"
                v-model="formData.service_state"
                style="justify-content: space-evenly"
              >
                <el-radio label="待发货">待发货</el-radio>
                <el-radio label="已发货">已发货</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>物流类型</p>
            <div class="radio_box" style="margin-bottom: 10px">
              <el-radio-group
                direction="horizontal"
                v-model="formData.service_company"
                style="justify-content: space-evenly"
              >
                <el-radio
                  v-for="(item, index) in logisticsList"
                  :key="index"
                  :label="item.evalue"
                  >{{ item.etext }}</el-radio
                >
              </el-radio-group>
            </div>
          </div>
          <div class="block">
            <p>发货物流单号</p>
            <div class="input_box">
              <el-input
                v-model="formData.service_no"
                placeholder="请填写发货物流单号"
              ></el-input>
            </div>
          </div>
          <div class="block">
            <p>
              发货门店<span class="mark"
                >“非必填项，如非门店发货，则无需选择”</span
              >
            </p>
            <div class="select_box">
              <el-select
                v-model="formData.service_shop"
                placeholder="请选择发货门店"
              >
                <el-option
                  v-for="item in shopList"
                  :key="item.shopid"
                  :label="item.shopname"
                  :value="item.shopid"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="block" v-if="false">
            <p>
              库源信息<span class="mark"
                >“非必填项，如无库源信息，则无需选择”</span
              >
            </p>
            <p v-html="formData.warehouse"></p>
            <!-- <div class="input_box">
              <el-input
                v-model="formData.warehouse"
                placeholder="库源信息"
                readonly
              ></el-input>
            </div> -->
          </div>
        </div>
        <!-- <div class="tip_wrap">
          <div class="item">
            <h1>商品SKU采购编码：</h1>
            <p>{{ detail.sku }}</p>
          </div>
          <div class="item">
            <h1>商品ISBN编码：</h1>
            <p>{{ detail.ISBN }}</p>
          </div>
          <div class="item">
            <h1>商品品牌：</h1>
            <p>{{ detail.brandname }}</p>
          </div>
        </div> -->
      </div>
    </div>
    <div class="form_footer flex-rowl">
      <div class="btn" @click="query">确认</div>
      <div class="return_txt" @click="handleReturn">←返回</div>
    </div>
    <!--  主要内容 end -->
  </div>
</template>

<script>
import { getShopList, getLogistics, encryptstringview } from "../../api/api";
import { getLogisticsDetail, editLogistics } from "../../api/shop";
export default {
  name: "outboundEdit",
  data() {
    return {
      loading: false,
      columns: [],
      formData: {
        Method: "ams_shop_wlserviceedit",
        id: "",
        orderid: "",
        orderno: "",
        qyguid: "",
        qyname: "",
        service_state: "",
        service_company: "",
        isrec: "",
        service_no: "",
        service_shop: "",
        order_addr: "",
      },
      service_shopstr: "", // 门店名称

      // 门店参数
      shopData: {
        Page: 1,
        PageSize: 100,
        qyguid: "",
      },
      shopList: [], // 门店列表

      // 物流订单
      logisticsList: [],
    };
  },
  created() {
    let { routerList, OPENID, USERINFO } = this.$store.state;
    let { name } = this.$route;

    this.shopData.qyguid = USERINFO.qy ? USERINFO.qy.qyguid : "";

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.formData.id = id;
        this.getLogisticsDetail();
        this.getShopList();
        this.getLogistics();
      } else {
        this.$router.back();
      }
    },

    // 仓库配货列表
    getLogisticsDetail() {
      this.loading = true;
      getLogisticsDetail({ id: this.formData.id }).then((res) => {
        this.formData.orderid = res.orderid ? res.orderid : "";
        this.formData.orderno = res.orderno ? res.orderno : "";
        this.formData.qyguid = res.qyguid ? res.qyguid : "";
        this.formData.qyname = res.qyname ? res.qyname : "";
        this.formData.service_state = res.service_state
          ? res.service_state
          : "";
        this.formData.service_company = res.service_company
          ? res.service_company
          : "";
        this.formData.isrec = res.isrec ? res.isrec : "";
        this.formData.service_no = res.service_no ? res.service_no : "";
        this.formData.service_shop = res.service_shop
          ? parseFloat(res.service_shop)
          : "";
        this.service_shopstr = res.service_shopstr ? res.service_shopstr : "";
        this.formData.order_addr = res.order_addr ? res.order_addr : "";
        this.loading = false;
      });
    },
    // 获取门店
    getShopList() {
      getShopList(this.shopData).then((res) => {
        this.shopList = this.shopList.concat(...res);
      });
    },
    // 物流订单类型
    getLogistics() {
      getLogistics().then((res) => {
        this.logisticsList = res;
      });
    },
    // 触底加载更多
    handleChangePopup() {
      const picker = this.$refs.picker;
      let { shopList, shopData } = this;
      if (
        shopList.length - 1 == picker.getIndexes().toString() &&
        shopList.length >= shopData.Page * shopData.PageSize
      ) {
        this.shopData.Page += 1;
        this.getShopList();
      }
    },

    // 触发门店
    handleShopList() {
      this.isShow = true;
      this.getShopList();
    },

    // 保存
    query() {
      let { formData } = this;
      console.log(formData, "====formDataformData");
      if (formData.service_state == "") {
        this.$message.warning("请选择订单物流状态");
        return;
      }
      if (formData.service_company == "") {
        this.$message.warning("请选择物流类型");
        return;
      }
      if (formData.service_no == "") {
        // this.$message.warning('请填写发货物流单号')
        // return
        this.$confirm("物流单号必须填写，否则不能保存", {
          confirmButtonText: "确定",
          cancelButtonText: "再等等",
          type: "warning",
        })
          .then(() => {
            // this.editLogistics()
          })
          .catch(() => {
            // this.$message({
            //   type: "info",
            //   message: "已取消删除",
            // });
          });
      } else {
        this.editLogistics();
      }
    },

    // 发货
    editLogistics() {
      let { formData } = this;
      this.loading = true;
      editLogistics(formData).then((res) => {
        let data = res;
        if (data.result) {
          setTimeout(() => {
            this.loading = false;
            this.$router.back();
          }, 500);
        } else {
          this.loading = false;
          this.$message.error(data.message || "服务器报错，请稍后～");
        }
      });
    },

    // 返回
    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  .form_container {
    .content_wrap {
      .form_wrap {
        margin-right: 100px;
      }
      .tip_wrap {
        flex: 1;
        .item {
          margin-bottom: 30px;
          color: #6e6e6e;
          h1 {
            margin-bottom: 8px;
            font-size: 18px;
          }
          p {
            font-size: 16px;
          }
        }
      }
    }
  }
}
</style>